import { createClient } from '@supabase/supabase-js';
import {queryCache} from './queryCache';
import {recordGenerationClock} from '../features/knowledge/generationClock';
export const configured = Boolean(import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_ANON_KEY);
export const supabase = configured ? createClient(import.meta.env.VITE_SUPABASE_URL, import.meta.env.VITE_SUPABASE_ANON_KEY) : null;
let cacheUser:string|undefined;
supabase?.auth.onAuthStateChange((event,session)=>{
  if(event==='SIGNED_OUT'||cacheUser!==session?.user.id)queryCache.clearSession();
  else if(event==='USER_UPDATED')queryCache.invalidate();
  cacheUser=session?.user.id;
});
export class ApiError extends Error { constructor(public code:string,message:string){super(message)} }
export async function api<T>(operation:string,input:unknown={}):Promise<T> {
  if (!supabase) throw new ApiError('unavailable','CAP4Publish mangler forbindelse til Dash-backend.');
  const epoch=queryCache.sessionEpoch;
  const {data:{session}}=await supabase.auth.getSession();
  if (!session) throw new ApiError('forbidden','Log ind igen for at fortsætte.');
  if(epoch!==queryCache.sessionEpoch)throw new ApiError('forbidden','Adgangen er ændret. Hent indholdet igen.');
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20_000);
  try{
    const response=await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/cap4publish-api`,{method:'POST',signal:controller.signal,headers:{'Content-Type':'application/json',Authorization:`Bearer ${session.access_token}`,apikey:import.meta.env.VITE_SUPABASE_ANON_KEY},body:JSON.stringify({operation,input})});
    const result=await response.json().catch(()=>null);
    if(epoch!==queryCache.sessionEpoch)throw new ApiError('forbidden','Adgangen er ændret. Hent indholdet igen.');
    if (!result || result.ok!==true){
      if(result?.code==='forbidden')queryCache.denyAccess();
      throw new ApiError(result?.code ?? 'unavailable',result?.message ?? `Forbindelsen svarede ${response.status}. Dine lokale ændringer er bevaret.`);
    }
    if(epoch!==queryCache.sessionEpoch)throw new ApiError('forbidden','Adgangen er ændret. Hent indholdet igen.');
    // Preparation is polled; its caller invalidates only when the preparation state changes.
    if(operation!=='prepareArticlePublication'&&!/^(get|list|preview)/.test(operation))queryCache.invalidate();
    recordGenerationClock(result.value);
    return result.value as T;
  }catch(error){
    if(controller.signal.aborted)throw new ApiError('unavailable','Det tager længere tid end forventet. Prøv igen. Dine lokale ændringer er bevaret.');
    throw error;
  }finally{clearTimeout(timer)}
}
export const operationId=()=>crypto.randomUUID();
export const message=(e:unknown)=>e instanceof Error?e.message:'Handlingen kunne ikke gennemføres.';
